import { clearUserData } from 'modules/common';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { logout } from '../../modules/authentication';
import { UserType } from '../../types/UserTypes';
import AccountMenu from '../accountMenu/AccountMenu';
import Button from '../button/Button';
import Hamburger from './Hamburger';
import {
  Brand,
  Logo,
  Menu,
  MenuItem,
  MenuWrapper,
  Wrapper,
} from './Header.styles';

interface HeaderProps {
  user: UserType;
}

// TODO: Adjust Acount menu based on user type options
// const commonOptions = [
//   {
//     text: 'Logout',
//     onClick: () => {},
//   },
// ];

// const shippingCompanyOptions = [
//   {
//     text: 'Exports',
//     onClick: () => {},
//   },
//   {
//     text: 'Saved suppliers',
//     onClick: () => {},
//   },
//   {
//     text: 'Edit profile',
//     onClick: () => {},
//   },
//   {
//     text: 'Preferences',
//     onClick: () => {},
//   },
//   {
//     text: 'Change password',
//     onClick: () => {},
//   },
//   ...commonOptions,
// ];

// const supplierOptions = [];

// const adminOptions = [];

// const brokerOptions = [];

const Header = ({ user }: HeaderProps): JSX.Element => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const router = useRouter();
  return (
    <Wrapper>
      <Brand href="/">
        <Logo src="/Bid2board.png" alt="bid2board" />
      </Brand>
      <MenuWrapper>
        <Menu isOpen={isMenuOpen}>
          {user &&
            (isMenuOpen ? (
              <MenuItem href="/dashboard" isOpen={isMenuOpen} button>
                Dashboard
              </MenuItem>
            ) : (
              <Button
                kind="primary"
                text="Dashboard"
                onClick={() => {
                  if (
                    typeof window !== 'undefined' &&
                    window.location.pathname === '/dashboard'
                  ) {
                    router.reload();
                  } else {
                    router.push('/dashboard');
                  }
                }}
                size="lg"
              />
            ))}
          <MenuItem href="/" isOpen>
            Home
          </MenuItem>
          <MenuItem href="/ship-managers" isOpen>
            Ship Managers
          </MenuItem>
          <MenuItem href="/service-suppliers" isOpen>
            Service Suppliers
          </MenuItem>
          <MenuItem href="/support" isOpen>
            Support
          </MenuItem>
          <MenuItem href="/contact" isOpen>
            Contact
          </MenuItem>
          {user && (
            <>
              {user.type === 'SHIPPING_COMPANY' && (
                <MenuItem href="/exports" isOpen={isMenuOpen}>
                  Exports
                </MenuItem>
              )}
              {user.status === 'APPROVED' &&
              user.type !== 'SHIPPING_COMPANY' ? (
                <MenuItem href="/transactions" isOpen={isMenuOpen}>
                  Transactions
                </MenuItem>
              ) : null}
              {user.type === 'SHIPPING_COMPANY' && (
                <MenuItem href="/saved-suppliers" isOpen={isMenuOpen}>
                  Saved suppliers
                </MenuItem>
              )}
              <MenuItem href="/edit-profile" isOpen={isMenuOpen}>
                Edit profile
              </MenuItem>
              <MenuItem href="/preferences" isOpen={isMenuOpen}>
                Preferences
              </MenuItem>
              <MenuItem href="/change-password" isOpen={isMenuOpen}>
                Change password
              </MenuItem>
              <MenuItem
                href="/"
                onClick={() => clearUserData()}
                isOpen={isMenuOpen}
              >
                Logout
              </MenuItem>
            </>
          )}
          {!user &&
            (isMenuOpen ? (
              <MenuItem href="/login" isOpen={isMenuOpen} button>
                Login
              </MenuItem>
            ) : (
              <Button
                kind="primary"
                text="Login"
                onClick={() => router.push('/login')}
                size="lg"
              />
            ))}
        </Menu>
        <Hamburger onClick={setIsMenuOpen} />
        {user && (
          <AccountMenu
            image={user.logo || ''}
            options={[
              ...(user.status === 'APPROVED' && user.type !== 'SHIPPING_COMPANY'
                ? [
                    {
                      text: 'Transactions',
                      onClick: () => router.push('/transactions'),
                    },
                  ]
                : []),

              ...(user.type === 'SHIPPING_COMPANY'
                ? [
                    {
                      text: 'Exports',
                      onClick: () => router.push('/exports'),
                    },
                  ]
                : []),

              ...(user.type === 'SHIPPING_COMPANY'
                ? [
                    {
                      text: 'Saved suppliers',
                      onClick: () => router.push('/saved-suppliers'),
                    },
                  ]
                : []),
              {
                text: 'Edit profile',
                onClick: () => router.push('/edit-profile'),
              },
              {
                text: 'Preferences',
                onClick: () => router.push('/preferences'),
              },
              {
                text: 'Change password',
                onClick: () => router.push('/change-password'),
              },
              {
                text: 'Logout',
                onClick: async () => {
                  await logout();

                  clearUserData();

                  if (router.pathname === '/') {
                    router.reload();
                  } else {
                    router.push('/');
                  }
                },
              },
            ]}
          />
        )}
      </MenuWrapper>
    </Wrapper>
  );
};

export default Header;
